// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "\n", "",{"version":3,"sources":[],"names":[],"mappings":"","file":"colors.css"}]);
// Exports
exports.locals = {
	"lightblue": "#8fdbf6",
	"orange": "#f7b82e",
	"yellow": "#ffe745",
	"green": "#64cf73",
	"darkblue": "#0e4375"
};
module.exports = exports;
